import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/common";
import { SOLUTIONS } from "../data/content";
import { Seo, breadcrumbs } from "../components/Seo";

export default function Solutions() {
  return (
    <div data-testid="solutions-page" className="pt-32">
      <Seo title="Finance Solutions" path="/solutions" description="Explore DNA Finance's commercial funding solutions: asset finance, commercial and buy-to-let mortgages, bridging, development finance, acquisition finance, invoice finance, trade finance, merchant cash advance and business loans." jsonLd={breadcrumbs([{ name: "Home", path: "/" }, { name: "Solutions", path: "/solutions" }])} />
      <section className="container-x mx-auto max-w-[1400px] py-16">
        <Reveal className="max-w-2xl mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-lime mb-4">Funding Solutions</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter">Commercial finance for every requirement</h1>
          <p className="text-grey text-lg mt-6 leading-relaxed">From asset finance to development funding, we arrange the right facility from across our 165+ lender panel.</p>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-px bg-[#808080]/20 border border-[#808080]/20">
          {SOLUTIONS.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 5) * 0.06}>
              <Link to={`/solutions/${s.slug}`} data-testid={`solutions-card-${s.slug}`} className="group block bg-[#1A1A1A] p-8 h-full hover:bg-[#111] transition-colors relative">
                <div className="flex items-start justify-between">
                  <s.icon className="w-10 h-10 text-lime group-hover:-translate-y-1 transition-transform" strokeWidth={1.5} />
                  <ArrowUpRight className="w-5 h-5 text-grey group-hover:text-lime transition-colors" />
                </div>
                <h3 className="text-xl font-bold mt-6 group-hover:text-lime transition-colors">{s.title}</h3>
                <p className="text-grey text-sm mt-3 leading-relaxed">{s.blurb}</p>
                <div className="absolute bottom-0 left-0 h-0.5 w-0 bg-lime group-hover:w-full transition-all duration-300" />
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
